import {getInternalWebsiteBaseUrl} from '../../../web-common/scripts/utils/whitelabelUtils';
import history from './history';

function backToAgenda({event, isWidget, serverRendered}) {
    const path = isWidget ? 'agenda?widget=true' : 'agenda';
    const url = getInternalWebsiteBaseUrl(event, path);
    serverRendered
        ? history.push(url)
        : history.goBack();
}

export default backToAgenda;
